import { useArchiveUser } from '../hooks/useArchiveUser'

/**
 * Header link to the media archive, which also tells a signed-in user that their downloads are
 * being filed there. Reserves its height while the session is still resolving so the layout does
 * not shift, and so no visitor is briefly shown a signed-out state that may not be true.
 */
export function ArchiveStatus() {
  const { user, isResolved } = useArchiveUser()

  if (!isResolved) {
    return <div className="h-5 mb-6" aria-hidden="true" />
  }

  if (!user) {
    return (
      <a
        href="/login.html"
        className="block text-center text-white/60 text-sm mb-6 hover:text-white"
      >
        My Media Archive →
      </a>
    )
  }

  return (
    <div className="text-center mb-6">
      <a href="/gallery.html" className="text-white/60 text-sm hover:text-white">
        My Media Archive →
      </a>
      <p className="text-white/40 text-[13px] mt-1">
        Signed in — downloads are added to your Downloads album
      </p>
    </div>
  )
}
